import React, { useState } from 'react';
import { OrderTag } from '../../Order/OrderBasicInfo/OrderTags';
import { ChevronRight } from 'sushiweb/Icons';
import { Tooltip } from '../../../../UiKit';

export const ValetTags = ({ valet = null }) => {
  const [showAllTags, setShowAllTags] = useState(false);
  const tags = valet?.tags || [];

  if (!Array.isArray(tags) || !tags || tags.length === 0) return null;

  // Accessibility tags are surfaced as a dedicated banner in ValetInfoV1
  // instead of the tag row, so they are excluded here.
  const ACCESSIBILITY_TAG_TEXTS = [
    'Physically Disabled Rider',
    'Hearing/Speech Impaired Rider',
  ];
  const validTags = tags
    .filter(Boolean)
    .filter((tag) => !ACCESSIBILITY_TAG_TEXTS.includes(tag?.text));

  if (validTags.length === 0) return null;

  const visibleTags = validTags.slice(0, 1);
  const hiddenTags = validTags.slice(1);
  const shouldShowChevron = validTags.length > 1;

  const renderTag = (item, key) => {
    return (
      <Tooltip
        key={key || item.text}
        title={
          <OrderTag bgColor={item.bg_color} textColor={item.color}>
            <span className='tw-lowercase first-letter:tw-uppercase'>
              {item.text}
            </span>
          </OrderTag>
        }
        position='bottom'
        border={false}
        label={item.tool_tip}
      />
    );
  };

  const handleMouseEnter = () => {
    clearTimeout(window.hideMerchantTagsTimeout);
    setShowAllTags(true);
  };

  const handleMouseLeave = () => {
    window.hideMerchantTagsTimeout = setTimeout(() => {
      setShowAllTags(false);
    }, 300);
  };

  return (
    <div className='tw-flex tw-gap-2 tw-h-full'>
      {visibleTags.map((item, index) =>
        item?.text !== 'BLUE' ? renderTag(item, `visible-${index}`) : null,
      )}

      {shouldShowChevron && (
        <div className='tw-relative tw-inline-block'>
          <div
            className='tw-cursor-pointer tw-w-6 tw-rounded-md tw-flex tw-items-center tw-justify-center hover:tw-bg-grey-200/50 tw-transition-all tw-duration-200 tw-ease-in-out tw-p-[2px]'
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
          >
            <ChevronRight
              size={22}
              aria-hidden
              focusable='false'
              color='#318616'
            />
          </div>

          {/* Popover with remaining tags */}
          <div
            className={`tw-absolute tw-right-full tw-top-0 tw-mr-2 tw-z-20 tw-rounded-lg tw-bg-grey-200 tw-shadow-md tw-flex tw-items-start tw-justify-center tw-p-4 tw-flex-col tw-gap-2 tw-transition-all tw-duration-200 tw-ease-out ${
              showAllTags
                ? 'tw-opacity-100 tw-translate-x-0 tw-scale-100'
                : 'tw-opacity-0 tw-translate-x-[-8px] tw-scale-95 tw-pointer-events-none'
            }`}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
          >
            <span className='tw-font-medium tw-text-[1.2rem] tw-leading-tight tw-whitespace-nowrap'>
              Other Valet Tags:
            </span>
            <div className='tw-flex tw-flex-wrap tw-justify-start tw-items-start tw-gap-2 tw-max-w-xs'>
              {hiddenTags.map((item, index) =>
                renderTag(item, `hidden-${index}`),
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
